export function safeArea(value={}){
 const result={};
 for(const edge of ['top','right','bottom','left']){
  const n=value?.[edge]??10;
  if(typeof n!=='number'||!Number.isFinite(n)||n<0||n>=50)throw new Error('Safe-area margins must be numbers from 0 to less than 50 percent.');
  result[edge]=n;
 }
 return result;
}
export function compositionFrame(format,value){
 const match=/^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?)$/.exec(String(format));
 if(!match||Number(match[1])<=0||Number(match[2])<=0)return null;
 const width=Number(match[1]),height=Number(match[2]),margins=safeArea(value);
 return {width,height,x:width*margins.left/100,y:height*margins.top/100,safeWidth:width*(100-margins.left-margins.right)/100,safeHeight:height*(100-margins.top-margins.bottom)/100};
}
